import keyMirror from 'keymirror';

const Actions = keyMirror({
  APPLICATION_ERROR: null,

  BUILD_DATA_RECEIVED: null,

  LOAD_CLIENT_CONFIG: null,
  LOAD_INTL_MESSAGES: null,

  // fluxible-router actions
  NAVIGATE_START: null,
  NAVIGATE_SUCCESS: null,
  NAVIGATE_FAILURE: null,

  SIDEBAR_TOGGLE_CLICKED: null,

  LIST_FILTER_SET: null,
  LIST_FILTER_CLEAR: null,

  AUTHENTICATION_CHECK_STARTED: null,
  AUTHENTICATION_CHECK_COMPLETED: null,
  AUTHENTICATION_AUTHORIZATION_STARTED: null,
  AUTHENTICATION_AUTHORIZATION_COMPLETED: null,
  AUTHENTICATION_LOGGING_OUT_STARTED: null,
  AUTHENTICATION_LOGGING_OUT_COMPLETED: null,
  AUTHENTICATION_STARTED: null,
  AUTHENTICATION_COMPLETED: null,
  AUTHENTICATION_FAILED: null,
  AUTHENTICATION_CLEAR_FORM_STATE: null,
  ACTIVATION_KEY_FOUND: null,
  PASSWORD_RESET_STARTED: null,
  PASSWORD_RESET_COMPLETE: null,
  PASSWORD_RESET_FAILED: null,
  PASSWORD_FORGOT_STARTED: null,
  PASSWORD_FORGOT_COMPLETE: null,
  PASSWORD_FORGOT_FAILED: null,
  PASSWORD_RESET_FORM_STATE_CHANGED: null,

  ACCOUNT_EDIT_BEGIN: null,
  ACCOUNT_EDIT_END: null,
  ACCOUNT_CLEAR_MESSAGES: null,
  ACCOUNT_UPDATE_INFORMATION: null,

  FAVORITES_RECEIVED: null,
  FAVORITES_ADDED: null,
  FAVORITES_REMOVED: null,

  CONVERSATION_HISTORY_CHANGED: null,
  CONVERSATION_PRODUCT_CATEGORY_CHANGED: null,

  SALES_LEADER_DATA_CHANGED: null,
  SALES_LEADER_QUERY_CHANGED: null,

  TEAM_PERFORMANCE_DATA_CHANGED: null,
  TEAM_PERFORMANCE_QUERY_CHANGED: null,
  TEAM_PERFORMANCE_REGIONS_CHANGED: null,

  TRAFFIC_SUMMARY_DATA_CHANGED: null,
  TRAFFIC_SUMMARY_QUERY_CHANGED: null,
  TRAFFIC_SUMMARY_REGIONS_CHANGED: null,
  USER_ACTION_DATA_LOADING: null,
  DEVICE_HISTORY_DATA_LOADING: null,

  USER_MANAGEMENT_SEARCH_CHANGED: null,

  USER_MANAGEMENT_ROLE_TOGGLED: null,
  USER_MANAGEMENT_ROLES_ENABLED: null,
  USER_MANAGEMENT_ROLES_DISABLED: null,
  USER_MANAGEMENT_ROLE_CHANGE_SAVED: null,

  USER_MANAGEMENT_LIST_MANAGED_USERS: null,
  USER_MANAGEMENT_LIST_USER_ROLES: null,

  USER_MANAGEMENT_SET_BRANCH_HIERARCHY_AND_TERMS: null,

  USER_MANAGEMENT_CREATE_NEW_USER: null,

  USER_MANAGEMENT_PII_CHANGED: null,
  USER_MANAGEMENT_PASSWORD_RESET_EMAIL_SENT: null,
  USER_MANAGEMENT_PASSWORD_RESET_CONFIRMATION_DISPLAYED: null,
  USER_MANAGEMENT_VALIDATION_ERROR_RECEIVED: null,
  USER_MANAGEMENT_RESET_VALIDATION_ERRORS: null,

  USER_MANAGEMENT_SHOW_NEW_USER_CREATED_REMINDER: null,
  USER_MANAGEMENT_CLEAR_NEW_USER_CREATED_REMINDER: null,
  USER_MANAGEMENT_SET_SHOW_INACTIVE_USERS: null,

  ONLINE_PERFORMANCE_DATA_CHANGED: null,
  ONLINE_PERFORMANCE_QUERY_CHANGED: null,
  ONLINE_PERFORMANCE_INTERVAL_CHANGED: null,
  ONLINE_PERFORMANCE_REGIONS_CHANGED: null,

  ONLINE_LEADER_DATA_CHANGED: null,
  ONLINE_LEADER_QUERY_CHANGED: null,
  ONLINE_LEADER_REGIONS_CHANGED: null,

  PRODUCT_ACTION_DATA_CHANGED: null,
  PRODUCT_ACTION_DATA_LOADING: null,
  PRODUCT_ACTION_QUERY_CHANGED: null,
  EDIT_PRODUCT_CLICKED: null,
  EDIT_PRODUCT_COMPLETE: null,
  PRODUCT_UPDATE_STARTED: null,
  PRODUCTS_LOADED: null,
  PRODUCTS_EXCLUDE_TOGGLE: null,
  PRODUCTS_EXCLUDED_QUERY: null,
  PRODUCTS_EXCLUDED_LOADED: null,
  PRODUCTS_EXCLUDED_FAILED: null,

  PRODUCT_MIX_QUERY_CHANGED: null,
  PRODUCT_MIX_DATA_LOADING: null,
  PRODUCT_MIX_DATA_CHANGED: null,
  PRODUCT_MIX_REGIONS_CHANGED: null,

  HISTOGRAM_DATA_CHANGED: null,

  QUERY_COMPLIANCE: null,
  COMPLIANCE_QUERIED: null,
  COMPLIANCE_QUERY_FAILED: null,
  COMPLIANCE_LIST_ITEM_FOCUSED: null,
  QUERY_CONVERSATION_FOR_COMPLIANCE: null,
  CONVERSATION_FOR_COMPLIANCE_QUERIED: null,
  CONVERSATION_FOR_COMPLIANCE_QUERY_FAILED: null,
  CLEAR_QUERIED_CONVERSATION_FOR_COMPLIANCE: null,

  ASSOCIATED_PRODUCTS_LOADED: null,
  PRODUCT_RULE_TYPES_LOADED: null,
  PRODUCT_COST_TYPES_LOADED: null,
  PRODUCT_LOCATION_SEARCH_UPDATED: null,
  PRODUCT_LOCATION_LOAD_ALL_CLIENT_BRANCHES: null,
  REQUIRED_PRODUCTS_LOADED: null,

  EMPLOYEES_LOAD_ALL: null,
  EMPLOYEES_LOADED: null,

  BANKINFO_LOAD_BANK: null,
  BANKINFO_UPDATE_BANK: null,
  BANKINFO_UPDATE_BRANCH: null,
  BANKINFO_BRANCH_SEARCH_TERM_CHANGED: null,
  BANKINFO_SET_SHOW_INACTIVE_BRANCHES: null,

  PUBLISH_LOAD_PUBLICATION: null,

  RECEIVE_GUIDES: null,
  RECEIVE_GUIDE: null,
  DOMAIN_VALIDATION_COMPLETE: null,
  GUIDE_SAVE_STARTED: null,
  GUIDE_SAVE_COMPLETED: null,

  CLIENT_DOMAIN_VALIDATION_COMPLETE: null,
  SIGN_UP_COMPLETE: null,
  SIGN_UP_PROCESSING: null,
  RESET_SIGN_UP: null,

  QUERY_HELP_VIDEO: null,
  HELP_VIDEO_QUERIED: null,
  HELP_VIDEO_QUERY_FAILED: null,

  GUIDE_COUNT_CHANGED: null,
  PAYMENT_TERM_CHANGED: null,
  SUPPORT_PACKAGE_CHANGED: null,
  BILLING_REQUEST_SUBMITTED: null,
  BILLING_REQUEST_RECEIVED: null,
  BILLING_REQUEST_ERROR: null,
  BILLING_REQUEST_STARTED: null,
  BILLING_REQUEST_CANCELLED: null,
  COST_TIER_RECEIVED: null,
  SUBSCRIPTION_RECEIVED: null,
  BILLNG_TRANSACTION_HISTORY_RECEIVED: null
});

export default Actions;



// WEBPACK FOOTER //
// ./src/constants/Actions.js